import React from 'react';
import { CircularProgress, Fab, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { styled } from '@mui/system';
import { uploadFiles } from 'src/services/file.service';
import { ReactWebStore } from 'react-webstore';
// import svg icon
import UploadIcon from 'src/assets/icons/upload.svg';

// ----------------------------------------------------------------------


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 0,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 0,
});

class FileUpload extends React.Component {

    constructor(props) {
        super(props);

        this.rws = new ReactWebStore();
        this.state = {
            loading: false,
        }
    }

    // promised setState
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }
        
    uploadFiles = async (files) => {
        if (!files || files.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No files selected for upload'
            });
            return;
        }

        this.rws.store('is_file_uploading', 'true');

        // Proceed with file upload
        this.setStateAsync({ loading: true });

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i]);
        }

        const uploadRes = await uploadFiles(formData);
        if (uploadRes.error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: uploadRes.error
            });
        } else {
            if (this.props.onUpload) {
                this.props.onUpload();
            }
        }

        this.rws.store('is_file_uploading', 'false');
        this.rws.store('sync_organizing_status', 'success');
        this.setStateAsync({ loading: false });
    }

    render() {
        return (
            <Tooltip title={this.state.loading ? "Uploading..." : "Upload File"} placement="top">
                <Fab size="small" color="secondary" aria-label="add"
                    // disabled={this.state.loading}
                >
                    <IconButton
                        color='secondary'
                        component="label"
                        variant="contained"
                        disabled={this.state.loading}
                    >
                        {/* Show loading spinner when uploading */}
                        {this.state.loading ? (
                            <CircularProgress size={20} style={{ color: 'white' }} />
                        ) : <img src={UploadIcon} alt="Upload" style={{ color: 'white', width: 35, height: 35 }} />}
                        
                        <VisuallyHiddenInput
                            type="file"
                            onChange={(e) => {
                                const files = e.target.files;
                                if (files && files.length > 0) {
                                    for (let i = 0; i < files.length; i++) {
                                        if (
                                            files[i].name.toLowerCase().endsWith('.svg') ||
                                            files[i].type === 'image/svg+xml' ||
                                            files[i].type.includes('image/svg')
                                        ) {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Invalid File',
                                                text: 'SVG files are not allowed.'
                                            });
                                            return;
                                        }
                                    }
                                    this.uploadFiles(files);
                                }
                                // Clear the input value after upload
                                e.target.value = null;
                            }}
                            multiple
                        />
                    </IconButton>
                </Fab>
            </Tooltip>
        );
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <FileUpload {...props} navigate={navigate} />;
}
